import React from 'react';
import {Check} from '@material-ui/icons';

const ShipmentCoaSuccessToast = ({visible, message}) => {
    if (!visible || !message) {
        return null;
    }

    return (
        <div className="shipment-coa-success-toast">
            <div className="shipment-coa-success-toast-icon">
                <Check className="shipment-coa-success-toast-check" />
            </div>
            <span className="shipment-coa-success-toast-message">
                {message}
            </span>
        </div>
    );
};

export default ShipmentCoaSuccessToast;
